<template>
  <van-pull-refresh v-model="list.refreshing" success-text="刷新成功" @refresh="onRefresh">
    <van-list v-model="list.loading" :class="isDouble ? 'double' : ''" error-text="请求失败，点击重新加载" :finished-text="finishedText" :finished="list.finished" :error.sync="list.error" :immediate-check="immediateCheck" @load="loadData">
      <slot :total="list.total" :items="list.items" :topItems="list.topItems" :loading="list.loading" />
      <template v-if="$slots.finished" slot="finished">
        <slot name="finished" />
      </template>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'BaseList',
  props: {
    deDuplication: Boolean,
    immediateCheck: {
      type: Boolean,
      default: true,
    },
    httpRequest: {
      type: Function,
      required: true,
    },
    queryParams: {
      type: Object,
    },
    // 接口内容返回后钩子
    afterAtFetched: Function,
    isDouble: {
      // 双栏
      type: Boolean,
      default: false,
    },
    // 网络招聘会去重处理
    fairUnique: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: {
        total: 0,
        items: [],
        topItems: [],
        loading: false,
        refreshing: false,
        finished: false,
        error: false,
      },
      pageParams: {
        index: 1,
        size: 10,
      },
    };
  },
  computed: {
    // ...mapGetters(['webSwitch']),
    finishedText() {
      return this.list.items.length ? '没有更多了' : '';
    },
  },
  watch: {
    queryParams: {
      handler() {
        this.query();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['getLocation']),
    query() {
      this.$set(this.list, 'finished', false);
      this.$set(this.list, 'error', false);
      this.$set(this.list, 'total', 0);
      this.$set(this.list, 'items', []);
      this.$set(this.list, 'topItems', []);
      this.$set(this.pageParams, 'index', 1);
      this.loadData();
    },
    onRefresh() {
      this.$set(this.list, 'items', []);
      this.$set(this.list, 'finished', false);
      this.$set(this.list, 'error', false);
      this.$set(this.list, 'refreshing', true);
      // 将 当前分页 设置为 0，表示第一页
      this.$set(this.pageParams, 'index', 1);
      // 重新加载数据
      this.loadData();
    },
    async loadData() {
      try {
        this.$set(this.list, 'loading', true);

        if (this.pageParams.index === 1) {
          window.scroll(0, 0);
        }

        let params = { ...this.queryParams, pageIndex: this.pageParams.index, pageSize: this.pageParams.size };

        // if ('region' in params && params.region * 1 === 0 && this.webSwitch.near_jobs_status) {
        //   const geo = await this.getLocation();
        //   params.lat = geo.latitude;
        //   params.lng = geo.longitude;
        // }
        let res = await this.httpRequest(params);
        if (typeof this.afterAtFetched === 'function') {
          res = this.afterAtFetched(res) || res; // 未返回内容则使用默认
        }
        if (this.list.refreshing) {
          this.$set(this.list, 'total', 0);
          this.$set(this.list, 'items', []);
          this.$set(this.list, 'topItems', []);
          this.$set(this.list, 'refreshing', false);
        }
        this.pageParams.index += 1;

        setTimeout(() => {
          this.$emit('fetch-success', res);
          let total = res.total !== undefined ? res.total : res.count
          this.$set(this.list, 'total', total);
          this.$set(
            this.list,
            'items',
            this.list.items.concat(res.items)
          );
          if (res.itemsTop) {
            this.$set(
              this.list,
              'topItems',
              this.list.topItems.concat(res.itemsTop)
            );
          }
          this.$set(this.list, 'loading', false);

          let pageAll = 0;
          if (total % params.pageSize === 0) {
            // 整页
            pageAll = total / params.pageSize;
          } else {
            // 非整页
            pageAll = (total - (total % params.pageSize)) / params.pageSize + 1;
          }

          if (this.pageParams.index > pageAll || total < res.pageSize) {
            this.$set(this.list, 'finished', true);
          }
        }, 300);
      } catch (err) {
        this.$set(this.list, 'loading', false);
        this.$set(this.list, 'finished', true);
        this.$set(this.list, 'error', true);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.double {
  display: flex;
  min-height: calc(100vh - 300px) !important;
  flex-wrap: wrap;
  justify-content: space-between;
  /deep/ .van-list__finished-text {
    width: 100%;
  }
}
</style>
